/**
 * Renders Zapier's `<zapier-zap-manager>` web component with Muster's OAuth
 * client id, letting users view and manage their Zaps in place. Used on the
 * Settings Integrations tab; requires the Zapier elements script to be loaded
 * globally.
 */
const ZapierComponent = () => (
  <div>
    <zapier-zap-manager
      client-id="2Db4AYHlkiz4ujMiZOhcHQg7lnunvvIhx0igXTg1"
      link-target="new-tab"
      theme="light"
    />
  </div>
);

export default ZapierComponent;
